// extracted by mini-css-extract-plugin
export default {"field":"BotIconUploader_field__StUWc","previewRow":"BotIconUploader_previewRow__aAfC-","actions":"BotIconUploader_actions__Rfy+S","hintError":"BotIconUploader_hintError__XhoEr"};